import Layout from './Layout'

export default function RunTimeError({ error }: { error: Error }) {
  return (
    <Layout>
      <div className="text-center p-4">
        <h1>Something went wrong</h1>
      </div>
    </Layout>
  )
}
